import { Params } from '@angular/router';
import { SearchValue } from './table-header.model';

export const mapQueryParamsToTableFilter = <TStatus extends string | number>(
  params?: Params,
): SearchValue<TStatus> => {
  return {
    search: params?.['search'] ?? null,
    status: params?.['status'] ?? null,
  };
};
